/**
 * @author Sarthak Sharma.
 * @since 31-01-2024.
 * @type {string} General action types.
 */

export const SET_LOADING = '[ARTIST_GENERAL] SET_LOADING';
export const SET_PROFILE_CATEGORY_LIST = '[ARTIST_GENERAL] SET_PROFILE_CATEGORY_LIST';
export const SET_LOCATION_LIST = '[ARTIST_GENERAL] SET_LOCATION_LIST';
export const SET_PROJECT_CATEGORY_LIST = '[ARTIST_GENERAL] SET_PROJECT_CATEGORY_LIST';
export const SET_ROLE_TYPE_LIST = '[ARTIST_GENERAL] SET_ROLE_TYPE_LIST';

export const SET_REPORT_TYPE_LIST = '[ARTIST_GENERAL] SET_REPORT_TYPE_LIST';
export const SET_REPORT_MODAL = '[ARTIST_GENERAL] SET_REPORT_MODAL';
export const SET_KYC_MODAL = '[ARTIST_GENERAL] SET_KYC_MODAL';

